export const getPriorityColor = (priority: string) => {
  switch (priority.toLowerCase()) {
    case 'high': return 'bg-destructive/10 text-destructive border-destructive/30';
    case 'medium': return 'bg-yellow-500/10 text-yellow-600 border-yellow-500/30';
    default: return 'bg-muted text-muted-foreground border-muted';
  }
};

export const getETypeColor = (eType: string) => {
  // Use the same brand color CSS classes as ETypeTag for consistent WCAG AA contrast
  switch (eType.toLowerCase()) {
    case 'education': return 'tag-education';
    case 'exposure': return 'tag-exposure';
    case 'experience': return 'tag-experience';
    default: return 'bg-muted text-muted-foreground border-muted';
  }
};
